/*
Model defined for Maintaining User Responses. It can also be used for transferring model
*/

export class ForgotPasswordRequest {
    id: string;
    type: string;
    userId: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/user/ForgotPasswordRequest.ts